import { render, staticRenderFns } from "./formDefault.vue?vue&type=template&id=73253ec6&scoped=true"
import script from "./formDefault.vue?vue&type=script&lang=js"
export * from "./formDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73253ec6",
  null
  
)

export default component.exports